<template>
  <div style="margin: 10px">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <!-- <h4>筛选查询</h4> -->
          <el-row>
            <el-col :span="24">
              <el-table
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                size="mini"
                ref="multipleTable"
                :data="tableData"
                style="width: 100%"
                border
                :header-cell-style="{ background: '#E5E7EE', color: '#000000' }"
                row-key="id"
              >
                <el-table-column
                  align="center"
                  :label="item.label"
                  v-for="(item, index) in tableHead"
                  :key="`col_${index}`"
                  :prop="item.prop"
                >
                </el-table-column>

                <el-table-column fixed="right" label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="success"
                      icon="el-icon-info"
                      circle
                      size="small"
                      @click.native.prevent="show(scope.row)"
                    ></el-button>
                    <!-- <el-button
                      type="danger"
                      icon="el-icon-delete"
                      circle
                      @click.native.prevent="deleteRow(scope.$index, scope.row)"
                      size="small"
                    ></el-button> -->
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog title="表格信息" :visible.sync="dialogVisible" width="95%" :before-close="handleClose" >
      <el-table
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                size="mini"
                ref="multipleTable"
                :data="allInfo"
                style="width: 100%"
                border
                :header-cell-style="{ background: '#E5E7EE', color: '#000000' }"
                row-key="id"
              >
                <el-table-column
                  align="center"
                  :label="item.label"
                  v-for="(item, index) in tableDialog"
                  :key="`col_${index}`"
                  :prop="item.prop"
                >
                <template >
                   <el-link :underline="false" :disabled="allInfo.length==0 ? true :allInfo[0][item.prop] == null? true :allInfo[0][item.prop].slice(0,5)=='https'? false :true" :href="allInfo.length==0? '' :allInfo[0][item.prop]">{{allInfo.length==0? '' :allInfo[0][item.prop]}}</el-link>
                </template>
                </el-table-column>
      </el-table>
		</el-dialog>
  </div>
</template>

<script>
import request from '../../../assets/js/request.js'
import qs from 'qs'
export default {
  data () {
    return {
      tableDialog:[],
      form: {
        one: '',
        two: '',
        three: '',
        title: ''
      },
      listOne: [],
      listTwo: [],
      listThree: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      multipleTable: [],
      loading: false,
      twoShow: false,
      threeShow: false,
      dialogVisible: false,
      
      tableHead:[],
      // 表格数据信息 一条信息
      tableData: [],

      // 一条表单的所有信息
      allInfo:[]
    }
  },
  watch: {
    '$route.query': {
      handler (query) {
        let path = this.$route.path
        this.loading = true
        // this.getData(this.currentPage, this.pageSize)
      }
    }

  },
  created () {
    this.getHead()
    this.getTable()
    // this.getData(this.currentPage, this.pageSize)
  },
  mounted () {
    this.rowDrop()
  },
  methods: {
    // 上移和下移动的接口
    // async moves (id, index) {
    //   const res = await this.$http({
    //     method: 'get',
    //     url: '/api/v2/news/change/order',
    //     params: {
    //       id: id,
    //       type: index
    //     }
    //   })
    //   console.log('点击排序', res)
    //   if (res.data.status === 200) {
    //     this.getData(this.currentPage, this.pageSize)
    //   } else {
    //     this.$message.error(res.data.message)
    //   }
    // },
    // 行拖拽
    // rowDrop () {
    //   const tbody = document.querySelector('.el-table__body-wrapper tbody')
    //   const _this = this
    //   this.Sortable.create(tbody, {
    //     onEnd ({
    //       newIndex,
    //       oldIndex
    //     }) {
    //       const currRow = _this.tableData.splice(oldIndex, 1)[0]
    //       _this.tableData.splice(newIndex, 0, currRow)
    //     }
    //   })
    // },
    clear () {
      this.form.title = ''
      this.getData(this.currentPage, this.pageSize)
    },
    // 获取表头数据
    getHead(){
      var obj = this
      obj.$http({
        method: 'get',
        url: '/api/v1/form/table',
        params: {
          cid: this.$route.query.id,
        }
      }).then((res) => {
        console.log(res)
        if (res.data.status == 200) {
          const data = res.data.data
          for(var i = 0;i<data.length;i++){
            const obj = {
              label:data[i].name,
              prop:'col_'+i
            }
            this.tableHead.push(obj)
            this.tableDialog.push(obj)
          }
          this.tableHead = this.tableHead.splice(0,5)
          console.log(this.tableHead)
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    // 获取表格信息
    getTable(){
      this.loading = true
      var obj = this
      obj.$http({
        method: 'get',
        url: '/api/v1/form/data',
        params: {
          cid: this.$route.query.id,
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.loading = false
          console.log(res.data.data.data,'表格信息')
          const tdata = res.data.data.data;
          this.total = tdata.length
          tdata.forEach((item,index)=>{
            const itemdata = JSON.parse(item.data)
            console.log(itemdata)
            var itemlist = {}
            for(var i = 0;i<itemdata.length;i++){
              this.$set(itemlist, 'col_'+i, itemdata[i].data)
            }
            console.log(itemlist)
            this.tableData.push(itemlist)
            console.log(this.tableData)
          })
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    // 获取分类
    getType () {
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/news/column/one',
        params: {
        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.listOne = res.data.data
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    getOne (event) {
      this.twoShow = true
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/news/column/child',
        params: {
          id: event
        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.listTwo = res.data.data
          this.threeShow = false
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    getTwo (event) {
      this.threeShow = true
      this.form.three = ''
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/news/column/child',
        params: {
          id: event
        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.listThree = res.data.data
        } else {
          obj.$message.error(res.data.message)
        }
      })
    },
    // 分页事件
    handleSizeChange (val) {
      this.pageSize = val // 将每页显示的条数 = 改变的值
      this.getData(this.currentPage, this.pageSize)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getData(this.currentPage, this.pageSize)
    },
    // 修改
    update (iden, rows) {
      console.log(rows)
      this.$router.push({
        path: '/home/artUpdate',
        query: {
          iden: iden,
          rows: rows,
          id: this.$route.query.id
        }
      })
    },
    // 查看详情
    async show(row){
      this.allInfo=[]
      console.log(row)
      this.dialogVisible = true
      this.allInfo.push(row)
      console.log(this.allInfo)
    },
    deleteRow (index, rows) {
      this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.loading = true
        var obj = this
        obj.$http({
          method: 'get',
          url: 'api/v1/news/clear',
          params: {
            ids: rows.id,
            uid: localStorage.getItem('uid')
          }
        }).then((res) => {
          if (res.data.status == 200) {
            this.loading = false
            obj.$message.success('删除成功')
            this.getData(this.currentPage, this.pageSize)
          } else {
            obj.$message.error(res.data.message)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 批量删除
    batDel () {
      if (this.$refs.multipleTable.selection.length == 0) {
        this.$message.error('请选择要删除的表格信息！')
        return
      }
      var list = []
      for (var i = 0; i < this.$refs.multipleTable.selection.length; i++) {
        list.push(this.$refs.multipleTable.selection[i].id)
      }
      this.$confirm('此操作将永久删除所选信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.loading = true
        var obj = this
        obj.$http({
          method: 'get',
          url: 'api/v1/news/clear',
          params: {
            ids: list.toString(),
            uid: localStorage.getItem('uid')
          }
        }).then((res) => {
          if (res.data.status == 200) {
            this.loading = false
            obj.$message.success('删除成功')
            this.getData(this.currentPage, this.pageSize)
          } else {
            obj.$message.error(res.data.message)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 全选
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 修改状态
    updateStatus (index, rows) {
      this.loading = true
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/news/change/status',
        params: {
          id: rows.id,

          status: rows.status
        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.loading = false
          obj.$message.success('修改成功')
          this.getData(this.currentPage, this.pageSize)
        } else {
          this.loading = false
          obj.$message.error(res.data.message)
        }
      })
    },
    // 修改置顶
    updateTop (index, rows) {
      this.loading = true
      var obj = this
      obj.$http({
        method: 'get',
        url: 'api/v1/news/change/roof',
        params: {
          id: rows.id,
          uid: localStorage.getItem('uid'),
          roof: rows.roof
        }
      }).then((res) => {
        if (res.data.status == 200) {
          this.loading = false
          obj.$message.success('修改成功')
          this.getData(this.currentPage, this.pageSize)
        } else {
          this.loading = false
          obj.$message.error(res.data.message)
        }
      })
    },
    handleClose(done) {
				done();
		}
  }
}
</script>

<style scoped="scoped">
/deep/ .el-form-item__label {
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
}

/deep/ .el-button--text {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #7c96f8;
  line-height: 24px;
}

span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #7c96f8;
  line-height: 24px;
}

.chenggong {
  width: 49px;
  height: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 24px;
  opacity: 0.7;
}

.fail {
  width: 33px;
  height: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #76b67e;
  line-height: 24px;
}

h4 {
  margin-bottom: 20px;
}
.tops {
  display: inline-block;
  width: 40px;
  margin-left: 20px;
  vertical-align: middle;
}
.tops i {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/content/form/form.vue